import styled from "styled-components";
import { Color } from 'styles';

export const StyledTextWrapper = styled.div`
  line-height: 34px;
  padding: 30px 0 160px;
  
  ol {
    li {
      span {
        background-color: ${Color.Orange};
        color: ${Color.White};
        padding: 0 7px;
      }
    }
  }
   
`;


// WEBPACK FOOTER //
// ./src/routes/textSubsite/textSubsite.style.js